import { BaseController } from '../../../common/base/controller';

export class PdfViewerController extends BaseController {
  constructor(controllerService, pdfViewerService) {
    'ngInject';
    super({ controllerService, pdfViewerService });
  }

  $onInit() {
    if (this.url) {
      this.pdfUrl = encodeURIComponent(this.url);
      return;
    }
    if (this.redirect) {
      this.getPdfDocumentUrl(this.src);
    } else {
      this.fetchPdf(this.src);
    }
  }

  $onChanges(changes) {
    this.$onInit();
  }

  getPdfDocumentUrl(url) {
    this.pdfViewerService.getPdfDocumentUrl(url).then((resp) => {
      this.fetchPdf(resp.data.base64Location);
    });
  }

  fetchPdf(url) {
    this.pdfViewerService.loadPdf(url).then((resp) => {
      this.pdfUrl = this.pdfViewerService.makeBase64Downloadable(resp.data);
    });
  }
}
